/**
 * Convert cents (integer) to display string.
 * e.g. 1299 → "12.99", 0 → "0.00", null/undefined → ""
 */
export function centsToDisplay(cents: number | null | undefined): string {
  if (cents === null || cents === undefined) return '';
  return (cents / 100).toFixed(2);
}

/**
 * Convert display string to cents (integer).
 * e.g. "12.99" → 1299, "" → null, "0" → 0
 */
export function displayToCents(display: string): number | null {
  if (!display || display.trim() === '') return null;
  const num = parseFloat(display);
  if (isNaN(num)) return null;
  return Math.round(num * 100);
}
